import {apiCall} from "../utils/apiCall";

export const DASHBOARD_LOADING_SUMMARY = "DASHBOARD_LOADING_SUMMARY";
export const GET_CUSTOMER_DASHBOARD_SUMMARY = "GET_CUSTOMER_DASHBOARD_SUMMARY";
export const GET_CUSTOMER_DASHBOARD_SUMMARY_FAIL = "GET_CUSTOMER_DASHBOARD_SUMMARY_FAIL";

export const getCustomerDashboardSummary = ({type} = {}) => {
    return apiCall({
        url: "order/customer_summary",
        method: "get",
        params: {type},
        successType: GET_CUSTOMER_DASHBOARD_SUMMARY,
        failType: GET_CUSTOMER_DASHBOARD_SUMMARY_FAIL,
        loadingType: DASHBOARD_LOADING_SUMMARY,
    });
};
